import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInfo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInfo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5830fe8df11754356da116dc4c097add7dc5c685', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '791a045dd5b30247c003121e859c8629dd16d5f1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7f6662da0b7c3b6cba5794fc803b4b3ccca1855c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0m16.5 0a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-6.25-3.44a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4 3.44v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4h-2a.5.5 0 0 1-.5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-info", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-info"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-info":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInfo$1);
            }
            break;
    } });
}

const CosmosIconInfo = CosmosIconInfo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInfo, defineCustomElement };
